document.documentElement.classList.remove('no-js');

(function () {
  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[–—]/g, '-')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mediaMatchesVariant(searchText, variantTitle) {
    var hay = normalize(searchText);
    var title = normalize(variantTitle);
    if (!hay || !title) return false;

    var isTwo = /(^|\s)(2|two|double)(\s|$)/.test(title);
    var isFour = /(^|\s)(4|four)(\s|$)/.test(title);
    var ready = title.indexOf('ready to fish') !== -1;
    var diy = title.indexOf('diy') !== -1 || title.indexOf('rigging') !== -1;
    var hiLo = title.indexOf('hi lo') !== -1;
    var complete = title.indexOf('complete surf rig') !== -1 || (title.indexOf('complete') !== -1 && title.indexOf('surf rig') !== -1);

    var hayTwo = /(^|\s)(2|two|double)(\s|$)/.test(hay) || hay.indexOf('two pack') !== -1 || hay.indexOf('2 pack') !== -1;
    var hayFour = /(^|\s)(4|four)(\s|$)/.test(hay) || hay.indexOf('four pack') !== -1 || hay.indexOf('4 pack') !== -1;
    var hayReady = hay.indexOf('ready to fish') !== -1 || hay.indexOf('rigged and ready') !== -1 || hay.indexOf('ready fish') !== -1;
    var hayNoHook = hay.indexOf('without hook') !== -1 || hay.indexOf('no hook') !== -1 || hay.indexOf('unrigged') !== -1 || hay.indexOf('diy') !== -1;
    var hayHiLo = hay.indexOf('hi lo') !== -1 || hay.indexOf('high low') !== -1;
    var hayComplete = hay.indexOf('complete surf rig') !== -1 || (hay.indexOf('complete') !== -1 && hay.indexOf('surf rig') !== -1);

    if (ready && isTwo) return hayReady && hayTwo;
    if (ready && isFour) return hayReady && hayFour;
    if (diy && isTwo) return hayNoHook && hayTwo;
    if (diy && isFour) return hayNoHook && hayFour;
    if (hiLo) return hayHiLo;
    if (complete) return hayComplete;

    // Generic fallback: require the meaningful words from the variant title.
    var ignored = { pack:1, rig:1, rigging:1, sandspawn:1, ready:1, fish:1, diy:1 };
    var words = title.split(' ').filter(function (word) { return word.length > 2 && !ignored[word]; });
    if (!words.length) return false;
    return words.every(function (word) { return hay.indexOf(word) !== -1; });
  }

  function initProductGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var mainImage = main && main.querySelector('img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var select = root.querySelector('[data-variant-select]');
    var price = root.querySelector('[data-product-price]');
    var hint = root.querySelector('[data-gallery-hint]');
    if (!mainImage || !thumbs.length) return;

    function updateGalleryShape() {
      if (!mainImage || !main) return;
      var w = mainImage.naturalWidth || 0;
      var h = mainImage.naturalHeight || 0;
      if (!w || !h) return;
      var ratio = w / h;
      main.classList.toggle('is-portrait', ratio < 0.9);
      main.classList.toggle('is-square', ratio >= 0.9 && ratio <= 1.1);
    }

    mainImage.addEventListener('load', updateGalleryShape);
    if (mainImage.complete) updateGalleryShape();

    function activate(thumb) {
      if (!thumb) return;
      thumbs.forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
      mainImage.src = thumb.dataset.fullSrc;
      if (thumb.dataset.fullSrcset) mainImage.srcset = thumb.dataset.fullSrcset;
      mainImage.alt = thumb.dataset.alt || '';
      if (mainImage.complete) updateGalleryShape();
    }

    function filterForVariant() {
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var variantTitle = option.dataset.variantTitle || option.textContent;
      var specificMatches = thumbs.filter(function (thumb) {
        return mediaMatchesVariant(thumb.dataset.mediaSearch || '', variantTitle);
      });

      // Keep universal product-detail views available while filtering pack/setup photos.
      // This includes the main single-lure hero, side/profile views, rear views,
      // scent-chamber closeups, and other non-pack-specific product photos.
      var sharedProfile = thumbs.filter(function (thumb) {
        var hay = normalize(thumb.dataset.mediaSearch || '');
        var hasQuantity = /(^|\s)(2|two|double|4|four)(\s|$)/.test(hay) ||
          hay.indexOf('two pack') !== -1 || hay.indexOf('2 pack') !== -1 ||
          hay.indexOf('four pack') !== -1 || hay.indexOf('4 pack') !== -1;
        var isSetupSpecific = hasQuantity ||
          hay.indexOf('ready to fish') !== -1 ||
          hay.indexOf('rigged and ready') !== -1 ||
          hay.indexOf('without hook') !== -1 ||
          hay.indexOf('no hook') !== -1 ||
          hay.indexOf('unrigged') !== -1 ||
          hay.indexOf('diy') !== -1 ||
          hay.indexOf('hi lo') !== -1 ||
          hay.indexOf('high low') !== -1 ||
          hay.indexOf('complete surf rig') !== -1;

        var explicitProfile = hay.indexOf('side profile') !== -1 ||
          hay.indexOf('profile') !== -1 ||
          hay.indexOf('rear view') !== -1 ||
          hay.indexOf('rear') !== -1 ||
          hay.indexOf('scent chamber') !== -1 ||
          hay.indexOf('close up') !== -1 ||
          hay.indexOf('closeup') !== -1 ||
          hay.indexOf('single') !== -1;

        return explicitProfile || !isSetupSpecific;
      });

      // Only filter when this variant actually has setup-specific media.
      // In that case show those images PLUS the shared profile/detail views.
      // Otherwise leave the full gallery visible as a safe fallback.
      if (specificMatches.length) {
        var visible = thumbs.filter(function (thumb) {
          return specificMatches.indexOf(thumb) !== -1 || sharedProfile.indexOf(thumb) !== -1;
        });
        thumbs.forEach(function (thumb) { thumb.hidden = visible.indexOf(thumb) === -1; });
        if (hint) hint.hidden = false;
        var activeVisible = thumbs.find(function (thumb) { return thumb.classList.contains('is-active') && !thumb.hidden; });
        activate(activeVisible || specificMatches[0] || sharedProfile[0]);
      } else {
        thumbs.forEach(function (thumb) { thumb.hidden = false; });
        if (hint) hint.hidden = true;
      }

      if (price && option.dataset.price) price.textContent = option.dataset.price;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activate(thumb); });
    });

    if (select) {
      select.addEventListener('change', filterForVariant);
      filterForVariant();
    }
  }

  document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
})();
